import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './Slide.css';

export default function Slide() {
  return (
    <>
      <Carousel controls={true} indicators={true} interval={3000}>

        <Carousel.Item>
          <a href='https://facisa.unimestresuperior.com/projetos/concurso/inscricao/index.php?&tid=0&lid=0&pid=concurso' className='slide-link'>
            <img
              className="d-block w-100"
              src="./assets/banner_vestibular_2026.2.png"
              alt="Banner vestibular"
            />
          </a>
        </Carousel.Item>
        <Carousel.Item>
          <a href='https://facisaba.edu.br/Edital' className='slide-link'>
            <img
              className="d-block w-100"
              src="./assets/banner_edital.png"
              alt="Banner edital aberto"
            />
          </a>
        </Carousel.Item>
        <Carousel.Item>
          <a href='/vestibular' className='slide-link'>
            <img
              className="d-block w-100"
              src="https://imgur.com/VKNMwfW.png"
              alt="Facisa credenciada"
            />
          </a>
        </Carousel.Item>
        <Carousel.Item>
          <a href='https://portal.dli.minhabiblioteca.com.br/Login.aspx?key=FACISA' className='slide-link'>
            <img
              className="d-block w-100"
              src="./assets/images/Banner_minhabiblioteca2.png"
              alt="Banner minha biblioteca"
            />
          </a>
        </Carousel.Item>
        <Carousel.Item>
          <a href='https://portal.dli.minhabiblioteca.com.br/Login.aspx?key=FACISA' className='slide-link'>
            <img
              className="d-block w-100"
              src="./assets/images/banner_minhabiblioteca.png"
              alt="Banner minha biblioteca"
            />
          </a>
        </Carousel.Item>
      </Carousel>
    </>
  );
}
